import { useStrategiesContext } from './StrategiesContext';
import { StrategyLineCard } from './StrategyLineCard';
import { useTranslation } from 'react-i18next';

export const List = () => {
  const { t } = useTranslation();
  const { activeStrategies, archivedStrategies, inactiveStrategies, filter } =
    useStrategiesContext();

  return (
    <>
      {activeStrategies.length > 0 && ['All', 'Active'].includes(filter) && (
        <>
          <h3 className="flex mt-8 text-lg font-semibold dark:text-white">
            {t('strategies.activeStrategies')} ({activeStrategies.length})
          </h3>
          {activeStrategies.map((strategy) => (
            <StrategyLineCard key={strategy.id} strategy={strategy} />
          ))}
        </>
      )}

      {inactiveStrategies.length > 0 &&
        ['All', 'Inactive'].includes(filter) && (
          <>
            <h3 className="flex mt-8 text-lg font-semibold dark:text-white">
              {t('strategies.inactiveStrategies')} ({inactiveStrategies.length})
            </h3>
            {inactiveStrategies.map((strategy) => (
              <StrategyLineCard key={strategy.id} strategy={strategy} />
            ))}
          </>
        )}

      {archivedStrategies.length > 0 &&
        ['All', 'Archived'].includes(filter) && (
          <>
            <h3 className="flex mt-8 text-lg font-semibold dark:text-white">
              {t('strategies.archivedStrategies')} ({archivedStrategies.length})
            </h3>
            {archivedStrategies.map((strategy) => (
              <StrategyLineCard key={strategy.id} strategy={strategy} />
            ))}
          </>
        )}
    </>
  );
};
